var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.5C0 1.58594 1.53125 0 3.5 0H24.5C26.4141 0 28 1.58594 28 3.5V17.5C28 19.4688 26.4141 21 24.5 21H3.5C1.53125 21 0 19.4688 0 17.5V3.5ZM2.625 3.5V4.75781L12.0312 12.4688C13.1797 13.3984 14.7656 13.3984 15.9141 12.4688L25.375 4.75781V3.5C25.375 3.0625 24.9375 2.625 24.5 2.625H3.5C3.00781 2.625 2.625 3.0625 2.625 3.5ZM2.625 8.14844V17.5C2.625 17.9922 3.00781 18.375 3.5 18.375H24.5C24.9375 18.375 25.375 17.9922 25.375 17.5V8.14844L17.6094 14.4922C15.4766 16.2422 12.4688 16.2422 10.3359 14.4922L2.625 8.14844Z",
    fill: "#25272C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.c6036af960b14f80ee6a94a5e1e8d708.svg";
export { ForwardRef as ReactComponent };